import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StatisticalForecastingOverviewComponent } from './statistical-forecasting-overview.component';

const routes: Routes = [{ path: '', component: StatisticalForecastingOverviewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class StatisticalForecastingOverviewRoutingModule { }
